import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/Analyics.module.css";
import clsx from "clsx";
import { Col, Image, Row } from "react-bootstrap";
import { TableCustom } from "@components/TableCustom/TableCustom";
import { myData } from "./DataTable";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from "chart.js";
import {
  dataBarChart,
  dataCurrentUsers,
  dataHorizontalDoubleLine,
  dataHorizontalLine,
  dataSales,
  optionsOverview,
  optionsSales,
  optionsUsers,
} from "./DataChart";
import gradient from "chartjs-plugin-gradient";

const Analyics = (props) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    gradient
  );
  // state

  // variables

  const columns = [
    {
      title: "Item No.",
      dataIndex: "id",
    },
    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      render: (thumbnail) => {
        return (
          <Image
            src={thumbnail}
            alt={"thumbnail"}
            className={clsx(styles.imgThumbnail)}
          />
          // <div>{`${moment(publishDate).format("DD MMMM YYYY | HH:mm")}`}</div>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Purchases",
      dataIndex: "purchases",
    },
    {
      title: "Comments",
      dataIndex: "comments",
    },
    {
      title: "Views",
      dataIndex: "views",
    },
  ];

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <div className={clsx(styles.container)}>
      <div className={clsx(styles.header)}>
        <i className="bi bi-graph-up" />
        Analyics
      </div>
      <Row
        className={clsx(styles.overviewContainer, "justify-content-between")}
      >
        <Col className={clsx(styles.overviewItem)}>
          <span className={clsx(styles.countNumber)}>839</span>
          <span className={clsx(styles.titleChart)}>Subscribers</span>
          <div>
            <Bar
              options={optionsOverview}
              data={dataBarChart}
              className="w-100"
            />
          </div>
        </Col>
        <Col className={clsx(styles.overviewItem)}>
          <span className={clsx(styles.countNumber)}>950</span>
          <span className={clsx(styles.titleChart)}>Weekly Visitors</span>
          <div>
            <Line
              options={{ ...optionsOverview, tension: 0.4 }}
              data={dataHorizontalDoubleLine}
              className="w-100"
            />
          </div>
        </Col>
        <Col className={clsx(styles.overviewItem)}>
          <span className={clsx(styles.countNumber)}>20</span>
          <span className={clsx(styles.titleChart)}>Weekly Sales</span>
          <div>
            <Line
              options={optionsOverview}
              data={dataHorizontalLine}
              className="w-100"
            />
          </div>
        </Col>
      </Row>
      <Row className={clsx(styles.saleChartContainer)}>
        <span className={clsx(styles.countNumber, styles.salesTitle)}>
          Sales Of The Year
        </span>
        <div>
          <Line
            options={{ ...optionsSales, tension: 0.4 }}
            data={dataSales}
            className={clsx("w-100", styles.salesChart)}
          />
        </div>
      </Row>
      <Row className={clsx(styles.userChartContainer)}>
        <Col className={clsx(styles.userActivity)}>Chart 1</Col>
        <Col className={clsx(styles.currentUsers)}>
          <span className={clsx(styles.countNumber, styles.usersTitle)}>
            Current Users
          </span>
          <div className={clsx(styles.titleUserChart)}>
            <span>Ave Page views per minute</span>
            <span>
              <b>09</b>
            </span>
          </div>
          <div className={clsx(styles.chartUsers)}>
            <Bar
              options={optionsUsers}
              data={dataCurrentUsers}
              className="w-100"
            />
          </div>
        </Col>
        {/* <Col className={clsx(styles.overviewItem)}>Chart</Col>
        <Col className={clsx(styles.overviewItem)}>Chart</Col> */}
      </Row>
      <TableCustom
        columns={columns}
        dataSource={myData}
        isLoading={false}
        className="text-center"
      />
      {/* <div>adsasddsa</div> */}
    </div>
  );
};

/* required: display name */
Analyics.displayName = "Analyics";

/* required: props types */
Analyics.propTypes = {};

/* required: default props */
Analyics.defaultProps = {};

export { Analyics };
